export const facebook = {
  name: "facebook" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M13.575 22.5H9.273V12H7.125V8.38h2.148V6.208c0-2.952 1.213-4.708 4.66-4.708h2.873v3.62h-1.795c-1.341 0-1.432.509-1.432 1.45l-.004 1.81h3.253l-.38 3.62h-2.869v10.5h-.004Z" clip-rule="evenodd"/></svg>`,
  keywords: ["facebook"],
  category: "social" as const,
};
